'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var service = require('../utils/service.js');

function createStart(_ref) {
  var network = _ref.network,
      preload = _ref.preload,
      peerId = _ref.peerId,
      keychain = _ref.keychain,
      repo = _ref.repo,
      ipns = _ref.ipns,
      mfsPreload = _ref.mfsPreload,
      print = _ref.print,
      hashers = _ref.hashers,
      options = _ref.options;

  var start = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$service$Servic, libp2p;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return service.Service.start(network, {
                peerId: peerId,
                repo: repo,
                print: print,
                hashers: hashers,
                options: options
              });

            case 2:
              _yield$service$Servic = _context.sent;
              libp2p = _yield$service$Servic.libp2p;
              _context.next = 6;
              return Promise.all([ipns.startOnline({
                keychain: keychain,
                libp2p: libp2p,
                peerId: peerId,
                repo: repo
              }), preload.start(), mfsPreload.start()]);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function start() {
      return _ref2.apply(this, arguments);
    };
  }();

  return start;
}

exports.createStart = createStart;